import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC } from 'react';

import { DrawerButton } from '@/components/button/icon-button';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

export const Header: FC = () => {
    const theme: any = useTheme();

    return (
        <>
            <Box
                sx={{
                    [theme.breakpoints.down('md')]: {
                        width: 'auto',
                    },
                }}
            >
                <DrawerButton />
            </Box>
        </>
    );
};
